import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import matter from "gray-matter";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

function BlogPost() {
  const { slug } = useParams();
  const [content, setContent] = useState("");
  const [meta, setMeta] = useState({});

  useEffect(() => {
    async function fetchPost() {
      const res = await fetch(`/blog/${slug}.md`);
      const text = await res.text();
      const { content: markdownContent, data } = matter(text);
      setContent(markdownContent);
      setMeta(data);
    }

    fetchPost();
  }, [slug]);

  useEffect(() => {
    document.title = meta.title ? `${meta.title} - Soham Jog` : "Soham Jog";
  }, [meta]);

  if (!meta.title) {
    return (
      <div className="flex min-h-screen items-center justify-center text-gray-500">
        Loading post...
      </div>
    );
  }

  return (
    <main className="mx-auto min-h-screen max-w-3xl px-6 pb-24 pt-12 sm:px-8">
      <div className="space-y-8">
        <Link
          to="/blog"
          className="inline-flex items-center gap-2 text-sm text-gray-500 transition-colors hover:text-gray-900"
        >
          <span aria-hidden="true">←</span>
          <span>Back to writing</span>
        </Link>

        <header className="space-y-4 border-b border-gray-200 pb-8">
          <time className="text-sm text-gray-500">{meta.date}</time>
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            {meta.title}
          </h1>
          {meta.description && (
            <p className="max-w-2xl text-lg leading-8 text-gray-700">
              {meta.description}
            </p>
          )}
        </header>

        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          className="prose prose-gray max-w-none prose-p:text-gray-700 prose-p:leading-8 prose-a:text-gray-900 prose-a:decoration-gray-300 prose-a:underline-offset-4 hover:prose-a:text-gray-700 prose-strong:text-gray-900 prose-code:rounded prose-code:bg-gray-100 prose-code:px-1 prose-code:py-0.5 prose-code:text-gray-900 prose-code:before:content-none prose-code:after:content-none prose-pre:border prose-pre:border-gray-200 prose-pre:bg-gray-50 prose-pre:text-gray-900 prose-blockquote:border-l-gray-300 prose-blockquote:text-gray-600 prose-img:rounded-sm"
        >
          {content}
        </ReactMarkdown>

        <footer className="border-t border-gray-200 pt-6 text-sm text-gray-500">
          <Link to="/" className="transition-colors hover:text-gray-900">
            Home
          </Link>
        </footer>
      </div>
    </main>
  );
}

export default BlogPost;
